import React, { useEffect, useRef } from "react";
import Router from "next/router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import "../global.css"
import Analytics from "../services/AnalyticsService";
// Pont iframe ⇄ site parent (taille de page postée au parent + CSS du parent
// injecté dans la page), monté uniquement en mode embed. Import STATIQUE et non
// `next/dynamic` : le composant ne rend rien (aucun DOM, tout est dans un
// useEffect) et pèse quelques lignes, alors qu'un chunk dynamique ajoute un
// aller-retour réseau au pire moment — la page embarquée doit annoncer sa
// hauteur au parent le plus tôt possible, sinon l'iframe reste à sa hauteur
// provisoire.
import EmbedBridge from "../components/EmbedBridge";
import { installNoZoom } from "../services/NoZoom";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "@flaticon/flaticon-uicons/css/all/all.css";
import "flag-icons/css/flag-icons.min.css";
import "../public/assets/css/custom-antd.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// NProgress : barre de progression top-page pendant les navigations.
// Remplace les setLoading(true) sur Router.events qui causaient des
// re-renders en cascade. Manipule directement le DOM (hors arbre React).
NProgress.configure({ showSpinner: false, trickleSpeed: 200 });

// Style de base partagé (hauteur, z-index, position).
// La couleur est overridée par chaque thème dans son injection CSS
// (TravelThemeVars, ThemeVars 2026, etc.) avec !important sur #nprogress.
if (typeof window !== "undefined") {
    const style = document.createElement("style");
    style.textContent = `
        #nprogress { pointer-events: none; }
        #nprogress .bar {
            position: fixed;
            z-index: 99999;
            top: 0;
            left: 0;
            width: 100%;
            height: 5px;
            background: #000;
        }
        #nprogress .peg {
            display: block;
            position: absolute;
            right: 0;
            width: 100px;
            height: 100%;
            opacity: 1;
            transform: rotate(3deg) translate(0, -4px);
            box-shadow: 0 0 12px #000, 0 0 6px #000;
        }
    `;
    document.head.appendChild(style);

    Router.events.on("routeChangeStart", () => NProgress.start());
    Router.events.on("routeChangeComplete", () => NProgress.done());
    Router.events.on("routeChangeError", () => NProgress.done());
}

//DEV
//import "../public/campagne/css/blue.css"
//import "../public/campagne/css/custom-brunoy.css"


//EDITOR
import '@kehila/react-page-editor/lib/index.css';

import '@react-page/plugins-background/lib/index.css';
import '@react-page/plugins-divider/lib/index.css';
import '@react-page/plugins-html5-video/lib/index.css';
import '@react-page/plugins-image/lib/index.css';
import '@react-page/plugins-spacer/lib/index.css';
import '@react-page/plugins-video/lib/index.css';

import '../components/WebEditor/plugins/quill/style.css';

import '@react-pdf-viewer/core/lib/styles/index.css';

export default function({ Component, pageProps }) {
    // Mesure d'audience (cookieless). On garde une ref vers les derniers
    // pageProps : sur navigation SPA, routeChangeComplete se déclenche AVANT
    // le re-render React, donc une closure capturerait des props périmées.
    // window.location.pathname (lu dans le service) est, lui, déjà à jour.
    const pagePropsRef = useRef(pageProps);
    useEffect(() => {
        pagePropsRef.current = pageProps;
    }, [pageProps]);

    // Premier chargement.
    useEffect(() => {
        Analytics.track(pagePropsRef.current);
    }, []);

    // Blocage du zoom (pinch + double-tap) DANS l'app mobile marque blanche. No-op
    // hors app → le site web classique garde le zoom (accessibilité). Couvre Android
    // + le double-tap iOS ; le pinch iOS est verrouillé à 100% côté natif (WebApp.js).
    useEffect(() => {
        const cleanup = installNoZoom();
        return cleanup;
    }, []);

    // Navigations SPA (bonus : ces sites sont majoritairement SSR full-load).
    useEffect(() => {
        const onRouteChange = () => Analytics.track(pagePropsRef.current);
        Router.events.on("routeChangeComplete", onRouteChange);
        return () => Router.events.off("routeChangeComplete", onRouteChange);
    }, []);

    return (
        <>
            {pageProps.render === "embed" && <EmbedBridge embed={pageProps.embed} eventContext={pageProps} />}
            <Component {...pageProps} />
        </>
    )
}
